import * as React from 'react';
import {AccountView} from '../../shared/filter/accountFilter';

export const AccountViewContext = React.createContext<AccountView | undefined>(
  undefined
);

export const useAccountView = (): AccountView => {
  const context = React.useContext(AccountViewContext);
  if (!context) {
    throw new Error(
      'useAccountView must be used within an AccountViewProvider'
    );
  }
  return context;
};

export function useIsMyAccountsView() {
  return useAccountView() !== 'recommended';
}
